// src/api/news.js
import request from '@/utils/request'

// api接口列表
const api = {
	type: 'category/list',
	list: 'article/list',
	detail: 'article/detail',
}


// 分类
export function type(params) {
	return request({
		url: api.type,
		method: 'get',
		params
	})
}
// 列表
export function list(params) {
	return request({
		url: api.list,
		method: 'get',
		params
	})
}

// 详情
export function detail(params) {
	return request({
		url: api.detail,
		method: 'get',
		params
	})
}